import React, { useEffect, useState } from "react";
import MessagePopup from "./MessagePopup";
import "./AnswerDisplay.scss";
import ReactMarkdown from "react-markdown";
import PlotlyGraph from "../layout/PlotlyGrapgh";
import Feedback from "../feedback/Feedback";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import QueryOptions from "./ResponseQueryOptions";
import { useMediaQuery } from "react-responsive";
import $ from "jquery";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import { ArrowRight, Download, RefreshCw } from "lucide-react";
const AnswerDisplay = ({
  item,
  query,
  setIsLoading,
  isLoading,
  index,
  printPDF,
  responseNumber,
  responseId,
  handlePin,
  pinError,
  isPinned,
  pinLoading,
  message,
  responceData,
  setResponceData,
  handleSendClickNew,
  displayedLogs
}) => {

  const [open, setOpen] = useState(false);
  const [currentMessage, setCurrentMessage] = useState("");
  const [openOptions, setOpenOptions] = useState(false);
  const [followUp, setFollowUp] = useState([]);
  const [followUpcount, setFollowUpcount] = useState(0);
  const [graphData, setGraphDataNew] = useState(item.figure);

  const handleExpandClick = (item) => {
    setCurrentMessage(item);
    setOpen(true);
  };
  function trimString(str, maxLength) {
    if (str.length > maxLength) {
      return str.substring(0, maxLength) + "...";
    }
    return str + " ...";
  }
  const getBackgroundColor = (score) => {
    const parsedScore = parseFloat(score);
    if (isNaN(parsedScore)) {
      return "red";
    }
    return parsedScore > 0.75 ? "green" : parsedScore > 0.5 ? "#FFC000" : "red";
  };
  const backgroundColor = getBackgroundColor(item.confidence_score);
  const isTab = useMediaQuery({ query: "(max-width: 768px)" });

  useEffect(() => {
    $(".summary-text").each(function () {
      // Select all <p> tags inside current .summary-text element except the first one
      // $(this).find('p:not(:first-child)').remove();
      const paragraphs = $(this).find("p");
      $(this).children(":not(p, pre)").remove();
      // Check number of <p> tags
      if (paragraphs.length > 1) {
        // Remove all <p> tags except the first one
        paragraphs.slice(1).remove();
      }
    });
  }, []);

  const question = message?.query ?? "";
  const chartId = `chart-${message?.message_id}`;
  const message_id = message?.message_id;

  const title = message?.query;

  const exportToPDF = (id, title) => {
    const element = document.getElementById(id);
    if (!element) {
      console.error(`Element with id ${id} not found`);
      return;
    }

    // Select all controls you want hidden during export
    const controls = element.querySelectorAll(
      ".export-btn, .expand-btn, .mobile-score-layout, .hideClass"
    );
    controls.forEach((btn) => btn.classList.add("no-export"));

    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("a4");

      const imgWidth = 180;
      const pageWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const marginTop = 20;
      const marginLeft = (pageWidth - imgWidth) / 2;

      pdf.addImage(imgData, "PNG", marginLeft, marginTop, imgWidth, imgHeight);
      pdf.save(`${title || "chart"}.pdf`);

      // Restore hidden controls
      controls.forEach((btn) => btn.classList.remove("no-export"));
    });
  };



  return (
    <div id={chartId}       
    style={{borderRight:"1px solid #eee", borderBottom:"1px solid #eee", borderTop:"1px solid #eee"}}
    className="p-6 rounded border-[#eee] border-l-[4px] border-l-[#bb1ccc] relative bg-white">

      
      <div className="first-info-cont mobile-header-layout">
        <div
          style={{
            display: "flex",
            justifyContent:
              item.header && isTab ? "space-between" : "space-between",
            width: "100%",
            alignContent: "center",
            alignItems: "center",
            paddingBottom: "20px",
          }}
        >
          <div
            className="mobileLayout-width"
            style={{ width: isTab ? "60%" : "80%" }}
          >
            <span className="font-bold text-[24px]">
              {item.header ? item.header : `Summary of ${question}`}
            </span>
          </div>

          <div
            style={{
              display: "flex",
              gap: "20px",
              justifyContent: "flex-end",
              alignContent: "center",
              alignItems: "center",
              justifyItems: "center",
            }}
            className="mobile-score-layout"
          >
            {/* <button className="bg-[#bb1ccc] p-[7px]  rounded text-white crusor-pointer" onClick={() => exportToPDF(chartId, title)}><Download/></button>

            {item.confidence_score !== undefined &&
              item.confidence_score !== "NA" && (
                <div
                  style={{
                    backgroundColor: backgroundColor,
                    color:
                      parseFloat(item.confidence_score).toFixed(2) > 0.75
                        ? "white"
                        : parseFloat(item.confidence_score).toFixed(2) > 0.5
                        ? "black"
                        : "white",
                    padding: "7px",
                    borderRadius: "6px",
                    // position: "absolute",
                    // top: "10px",
                    // right: "45px",
                    fontWeight: "600",
                  }}
                >
                  {parseFloat(item.confidence_score).toFixed(2)}
                </div>
              )} */}
            <div
              className={`three-dots-icon ${
                openOptions ? "option-active" : ""
              }`}
              onClick={() => {
                setOpenOptions((prevState) => true);
              }}
            >
              <MoreVertIcon />
            </div>
          </div>
        </div>
      </div>
      <ReactMarkdown className="summary-text">
        {item.summary.toLowerCase() === "na"
          ? item.message
          : responseNumber > 1
          ? item.summary
          : item.summary}
      </ReactMarkdown>
      {item.summary && item.summary.toLowerCase() !== "na" && (
        <div className="flex gap-1 font-semibold align-center hideClass pt-0">
          {/* For more details and follow up questions click on{" "}
          <ArrowRight width={15} /> */}
          <p
            className="read-more-btn text-[#bb1ccc] font-bold cursor-pointer flex gap-2"
            onClick={() => handleExpandClick(item)}
          >
            Read More <ArrowRight width={15} />
          </p>
        </div>
      )}
      {graphData && (
        <div className="relative">
          <PlotlyGraph
            graph={graphData}
            childId={item.child_question_id}
            version={item.version ? item.version : 1}
            AnswerDisplay="AnswerDisplay"
            messageID={responseId}
            tableCoumn={item.dataframe}
            setResponceData={setResponceData}
            responceData={responceData}
            setGraphDataNew={setGraphDataNew}
          />
        </div>
      )}
      <div className="HideMoreInPrints hideClass">
        <>
          {item.from_cache && (
            <div className="pb-2 text-gray-400 flex align-center gap-2 pb-2 text-[14px]">
              This response may be from cache. Please re-fetch if you need a
              fresh response.{" "}
              <button onClick={() => handleSendClickNew(question,message_id)} className="bg-[#bb1ccc] px-2 rounded cursor-pointer">
                <RefreshCw width={15} className="text-white" />
              </button>{" "}
            </div>
          )}
          {followUpcount > 0 && (
            <span className="pb-2 block text-gray-400 text-[14px]">
              Number of follow up available is{" "}
              <b className="text-[#bb1ccc]">{followUpcount}</b>{" "}
            </span>
          )}
          {/* <div className="pb-2">This responce is from cache from_cache</div> */}
          <Feedback
            feedbackStatus={item.feedback ? item.feedback : ""}
            messageID={responseId}
            index={index}
            child_response_id={index}
          />
        </>
      </div>
      <MessagePopup
        open={open}
        setOpen={setOpen}
        item={currentMessage}
        index={index}
        printPDF={printPDF}
        messageID={responseId}
        isPinned={isPinned}
        pinError={pinError}
        handlePin={handlePin}
        version={item.version ? item.version : 1}
        pinLoading={pinLoading}
        setCurrentMessage={setCurrentMessage}
        currentMessage={currentMessage}
        followUp={followUp}
        setFollowUp={setFollowUp}
        message={message}
        setFollowUpcount={setFollowUpcount}
        responceData={responceData}
        setResponceData={setResponceData}
        handleSendClickNew={handleSendClickNew}
        displayedLogs={displayedLogs}
        historyResponse={false}
        query={query}
      />{" "}
      {/* Pass the current message to the popup */}
      {openOptions && (
        <QueryOptions
          handleExpandClick={handleExpandClick}
          setOpenOptions={setOpenOptions}
          isPinned={isPinned}
          pinError={pinError}
          handlePin={handlePin}
          item={item}
          messageID={responseId}
          pinLoading={pinLoading}
          exportToPDF={exportToPDF}
          chartId={chartId}
          title={title}
          score={item.confidence_score}
          backgroundColor= {backgroundColor}
        />
      )}
    </div>
  );
};

export default AnswerDisplay;
